import './Language.scss';
import { Dropdown } from 'primereact/dropdown';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { setActiveLanguage } from '../../features/languageSlice';
import { useAppSelector } from '../../store/hooks';

const languages = [
    { value: 'eng', label: 'ENG', src: 'language-icons/en.png' },
    { value: 'tr', label: 'TR', src: 'language-icons/tr.png' },
];

export const Language = () => {
    const dispatch = useDispatch();
    const { i18n } = useTranslation();
    const [language, setLanguage] = useState(localStorage.getItem('activeLanguage') || 'tr');
    const langSlice = useAppSelector(state => state.language.activeLanguage)

    useEffect(() => {
        localStorage.getItem('activeLanguage');
    }, [])

    useEffect(() => {
        if (language) {
            dispatch(setActiveLanguage(language))
            i18n.changeLanguage(language);
        }
    }, [i18n, langSlice])

    const changeLanguage = (e: any) => {
        i18n.changeLanguage(e.value);
        setLanguage(e.value);
        dispatch(setActiveLanguage(e.value))
        localStorage.setItem('activeLanguage', e.value);
    }

    const selectedLanguageTemplate = (option: any, props: any) => {
        if (option) {
            if (langSlice !== null) {
                dispatch(setActiveLanguage(langSlice))
            } else if (langSlice === null) {
                const lang = localStorage.setItem('activeLanguage', option.value)
                dispatch(setActiveLanguage(lang))
            }
            return (
                <div className='country-item-value'>
                    <img draggable='false' alt={option.label} src={option.src} style={{ height: '15px' }} />
                    <div className='lang-span'>{option.label}</div>
                </div>
            );
        }
        return (
            <span>
                {props.placeholder}
            </span>
        );
    }

    const languageOptionTemplate = (option: any) => {
        return (
            <div className='country-item'>
                <img draggable='false' alt={option.label} src={option.src} style={{ height: '15px' }} />
                <div className='lang-span'>{option.label}</div>
            </div>
        );
    }

    return (
        <>
            <div className='Language'>
                <Dropdown
                    className='languages-dropdown'
                    value={language}
                    options={languages}
                    onChange={changeLanguage}
                    optionLabel='label'
                    valueTemplate={selectedLanguageTemplate}
                    itemTemplate={languageOptionTemplate}
                />
            </div>

        </>
    )
}

